import { AxiosErrorHandler, Card, Col, type EmptyProperties, InfinityLoading, Row, Skeleton } from 'ui';
import { ContentObjectRenderer } from '../content-object-renderer';
import { useContentObjectsInfiniteQuery } from '../queries';
import { ContentObjectFeedEmptyState } from './content-object-feed-empty-state';

type P = {
  communityId?: string;
  emptyState?: EmptyProperties;
  groupId?: string;
  pinned?: boolean;
  programId?: string;
  programTopicId?: string;
};

const ContentObjectFeed = ({ communityId, emptyState, groupId, pinned, programId, programTopicId }: P) => {
  const { data, error, fetchNextPage, hasNextPage, isFetching, isLoading } = useContentObjectsInfiniteQuery({
    communityId,
    groupId,
    pagination: { pageSize: 10 },
    pinned,
    programId,
    programTopicId,
  });

  const items = data?.pages.flat().flat();

  return (
    <AxiosErrorHandler error={error}>
      {isLoading || !items ? (
        <Skeleton active paragraph={{ rows: 12 }} />
      ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
      items.length === 0 ? (
        <ContentObjectFeedEmptyState emptyState={emptyState} />
      ) : (
        <Row gutter={[0, 'ms']}>
          {items.map((item) => (
            <Col key={item.id} span={24}>
              <Card marginBottom={false}>
                <ContentObjectRenderer item={item} key={item.id} view="feed" />
              </Card>
            </Col>
          ))}
          <Col justifyContent="center" span={24}>
            <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
          </Col>
        </Row>
      )}
    </AxiosErrorHandler>
  );
};

export default ContentObjectFeed;
